import { AccountingSingletonAccountsService_singletonAccountsServiceGetSingletonBalance } from '@festina/life-general-types/life/hooks/AccountingSingletonAccountsService_singletonAccountsServiceGetSingletonBalance'

export const useFetchAccountBalance =
  AccountingSingletonAccountsService_singletonAccountsServiceGetSingletonBalance.useSuspenseQuery
